export default __webpack_public_path__ + "static/media/gallery_09.bac7417b.jpg";